export default "__VITE_ASSET__gZy8BVDL__"